module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "press-3"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("音像电子出版物核验进度")]), _vm._v(" "), _c('a', {
    staticClass: "downBtn",
    attrs: {
      "href": _vm.filrUrl1,
      "download": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("下载封面和盖章页")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "核验年度",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("strTrans")(scope.row, "year")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "核验项目",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("strTrans")(scope.row.type, "type")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("strTrans")(scope.row, "pgstate")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.taskStatus == 7) ? _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goDeep(scope.row)
            }
          }
        }, [_vm._v("查看")]) : _vm._e()]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bf45e49"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pressRole/Audio_Electronic/examProgressHistory.vue
// module id = 1679
// module chunks = 1